var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareHeader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7C19.3807 7 20.5 5.88071 20.5 4.5C20.5 3.11929 19.3807 2 18 2C16.6193 2 15.5 3.11929 15.5 4.5C15.5 5.88071 16.6193 7 18 7Z",
    stroke: "#242629",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14C7.38071 14 8.5 12.8807 8.5 11.5C8.5 10.1193 7.38071 9 6 9C4.61929 9 3.5 10.1193 3.5 11.5C3.5 12.8807 4.61929 14 6 14Z",
    stroke: "#242629",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6L8.5 10",
    stroke: "#242629",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5L15.5 18",
    stroke: "#242629",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22C19.3807 22 20.5 20.8807 20.5 19.5C20.5 18.1193 19.3807 17 18 17C16.6193 17 15.5 18.1193 15.5 19.5C15.5 20.8807 16.6193 22 18 22Z",
    stroke: "#242629",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareHeader);
export default __webpack_public_path__ + "static/media/share-header.0dbad140.svg";
export { ForwardRef as ReactComponent };